import { useState } from "react";

import { Modal, Icons, Button } from "../../design";
import { useLoop } from "../loop-provider";
import { useAxios, handleError, emitCustomEvent } from "../../utils/helpers";
import { translate, translateLocalizedEntity } from "../../utils/translations";
import { EVENT_TYPES } from "../../utils/constants";

function UpdatePaymentMethodModal(props: any) {
    const [axios] = useAxios();
    const { token } = useLoop();
    const [isLoading, setisLoading] = useState(false);

    const handleConfirm = async () => {
        setisLoading(true);
        try {
            let _params: any = {
                token: token + "",
            };
            if (props.quickAction) {
                _params.quickActionUuid = props.quickAction.uuid;
            }
            const { data }: any = await axios.post(
                `${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/update_pm?` + new URLSearchParams(_params),
                { customerPaymentMethodId: props.pmId },
            );
            if (data?.success) emitCustomEvent(EVENT_TYPES.UPDATE_PAYMENT_METHOD_REQUESTED);
            props.displayActionMessage(
                getTranslation(data.messageKey, "updatePaymentPopupSuccessToast", data.placeholders),
                data.success,
            );
            if (data.success) {
                props.toggleActive();
            }
        } catch (error) {
            handleError(error, "components/modals/update-payment-method", "handleConfirm", {});
        }
        setisLoading(false);
    };

    function getTranslation(cpTranslationKey: string, quickActionTranslationKey: string, placeholders: any = null) {
        if (props.quickAction) {
            const translation = translateLocalizedEntity(
                "QUICK_ACTION_UPDATE_PAYMENT",
                props.quickAction.quickActionsStoreId,
                quickActionTranslationKey,
                "",
                placeholders,
            );
            if (translation) return translation;
            return translate(cpTranslationKey, placeholders);
        }
        return translate(cpTranslationKey, placeholders);
    }

    return (
        <Modal
            title={getTranslation("payment_update_popup_header", "updatePaymentPopupHeader")}
            active={props.active}
            toggleActive={props.toggleActive}
        >
            <Modal.Body>
                {isLoading ? <Icons.Spinner /> : getTranslation("payment_update_popup_body", "updatePaymentPopupBody")}
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex flex-row-reverse">
                    <Button disabled={isLoading} className="m-2" onClick={handleConfirm}>
                        {getTranslation("payment_update_popup_confirm_button", "updatePaymentPopupConfirmCTA")}
                    </Button>
                    <Button disabled={isLoading} variant="underline" className="m-2" onClick={props.toggleActive}>
                        {getTranslation("payment_update_popup_cancel_button", "updatePaymentPopupCancelCTA")}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default UpdatePaymentMethodModal;
